<template>
  <div>
    <template v-if="template === 'edit' || typeof template === 'undefined'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
      <input
        v-if        = "!field.readonly"
        :class      = "'qa-' +field.name + '__input'"
        :value      = "value"
        @input      = "update($event.target)"
        ref         = "input"
        type        = "number"
        placeholder = "0.00"
      />
      <input
        v-if        = "field.readonly"
        :class      = "'qa-' +field.name + '__input'"
        :value      = "value"
        type        = "number"
        placeholder = "0.00"
        readonly    = "readonly"
        disabled    = "disabled"
      />
    </template>
    <template v-if="template === 'detail'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
        <p
          class  = "u-paragraph"
          :class = "'qa-' + field.name + '__value'"
        >
          {{ formattedNumber(value) }}
        </p>
    </template>
  </div>
</template>

<script>
import $ from 'jquery'
import util from '@/functions'

export default {
  props: ['field', 'value', 'labelClass', 'template'],
  data: function () {
    return {
      maxLength: 14
    }
  },
  methods: {
    update (target) {
      // using valueAsNumber might clear the input in IE on invalid values
      let value = $(target)[0].value
      var formattedValue = value.trim()

      this.maxLength = formattedValue.indexOf('.') !== -1 ? 15 : 14
      if (formattedValue.indexOf('-') !== -1) {
        this.maxLength = this.maxLength + 1
      }
      if (formattedValue.length > this.maxLength) {
        formattedValue = formattedValue.slice(0, this.maxLength)
      }
      if (formattedValue !== value) {
        // This line prevent user from adding more than 14 or 15 digits in the input
        // normally it should update the model and the input but this doesn't work
        // as expected in here, it just updates the model but not the input value,
        // assigning the value directly into the input fix that issue
        this.$refs.input.value = formattedValue
      }
      this.$emit('input', formattedValue)
    },
    formattedNumber (value) {
      if (typeof value !== 'undefined' && value !== null) {
        var numberArray = value.toString().split('.')
        var integerPart = util.formatNumber(numberArray[0])
        numberArray[0] = integerPart
        return numberArray.join('.')
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldDecimal.vue?214f81a5